







import Vue from "vue";
import { Component } from "vue-property-decorator";
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import EmployeeInfo from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/EmployeeModels/EmployeeInfo";
@Component
export default class PageTeacherDetail extends Vue {
    
    model:WsResponseModel<EmployeeInfo> = null;

    created(){
        this.$api.EmployeeService.GetEmployeeDetailEvent
        .once(this.OnGetEmployeeDetail.bind(this));
        var id= this.$route.params.id;
        this.$api.EmployeeService.GetEmployeeDetail(Number(id));
    }

    OnGetEmployeeDetail(response:WsResponseModel<EmployeeInfo>){
        this.model = response;
    }
}
